module.exports = __webpack_public_path__ + "static/img/tsl.9e627721.jpg";